import { apiClient } from "model/axiosConfig";
import { languageForUrl } from "locales/languages";
import { typeZreportsFilters } from "./dZreportReducer";
import { typeRequestPagination } from "../system/constants";

// Type
export type typeZReportsRequestFilters = {
  filters: {
    closeDate?:
      | {
          from: string;
          to: string;
        }
      | {};
    fiscalCardId?: string | string[] | null;
    terminalSerianNumber?: string | string[] | null;
    store?: {
      id?: string;
    } | null;
    userName?: string[] | null;
  };

  pageFilter: typeRequestPagination;
  sortFilter: {
    direction: string;
    column: string;
  };
};

// Get Z-reports list
export const getZreportsList = async (payload: {
  filters: typeZreportsFilters;
  paginationRequest: typeRequestPagination;
}) => {
  const path = "/product/zreport/search";
  const config = {
    headers: {},
  };

  const data: typeZReportsRequestFilters = {
    filters: {},
    pageFilter: payload.paginationRequest,
    sortFilter: {
      direction: "DESC",
      column: "closeDate",
    },
  };
  if (payload.filters.userName)
    data.filters.userName! = [payload.filters.userName!];
  if (payload.filters.storeId)
    data.filters.store! = { id: payload.filters.storeId! };
  if (payload.filters.closeDate) {
    // @ts-ignore
    data.filters.closeDate! = payload.filters.closeDate;
  }
  if (payload.filters.terminalSerianNumber) {
    // @ts-ignore
    data.filters.terminalSerianNumber! = [payload.filters.terminalSerianNumber];
  }
  if (payload.filters.fiscalCardId) {
    // @ts-ignore
    data.filters.fiscalCardId! = [payload.filters.fiscalCardId];
  }
  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Export Z-reports list
export const exportZReportsList = async (payload: {
  zReportsIds: string[];
  lang: string;
}) => {
  const path = `/product/zreport/export?lang=${languageForUrl[payload.lang]}`;
  const config: { headers: {} } = {
    headers: {},
  };

  const data = payload.zReportsIds;

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Export Z-reports list
export const exportZReportsSales = async (payload: {
  zReportsIds: string[];
  lang: "ENG" | "RUS" | "UZB";
}) => {

  const path = `/product/sale/export?lang=${payload.lang}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const data = payload.zReportsIds

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};